module.exports = __webpack_public_path__ + "img/where_is_my_vn_vehicle.7cde1ed5.png";